import { Box, Pressable, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const ProductCardOptionSeparator = Box.withConfig({
  height: '1px',
  width: 'full',
  backgroundColor: primitive.$blackOpacity10,
});

export const ProductCardOptionsContainer = Box.withConfig({
  width: 'full',
  flexGrow: 1,
  alignItems: 'center',
  overflow: 'hidden',
});

export const ProductCardOption = Pressable.withConfig<{ $isSelected?: boolean }>(
  ({ $isSelected }) => ({
    flex: 1,
    width: 'full',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: $isSelected ? primitive.$bbqBrown : 'transparent',
  })
);

export const ProductCardOptionText = Text.withConfig<{ $isSelected?: boolean }>(
  ({ $isSelected }) => ({
    color: $isSelected ? primitive.$white : primitive.$bbqBrown,
  })
);
